import { makeStyles } from "@mui/styles";
const useSimpleButtonStyles = makeStyles(() => {
  return {
    primary: {
      background: "linear-gradient(90deg, #FF5D22 0%, #FB8C64 100%) !important",
      padding: "8px 16px !important",
      margin: "0 !important",
    },

    secondary: {
      border: "1px solid #FF6C37 !important",
      padding: "8px 26px !important",
    },

    disable: {
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
      background: "#BDBDBD",
      border: "none",
    },

    mobile: {
      padding: "10px !important",
    },
    button: {
      borderRadius: "4px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
      margin: "0 20px",
      alignItems: "center",
      justifyContent: "center",
      background: "none",
      border: "none",
    },

    loader: {
      color: "white !important",
      height: "20px !important",
      width: "20px !important",
    },
    loading: {
      cursor: "none !important",
    },

    text: {
      fontFamily: "Lato",
      textTransform: "none",

      "&.primary": {
        color: "white",
      },
      "&.secondary": {
        color: "#FF6C37",
      },
      "&.disable": {
        color: "white",
      },
      "&.exitDemoStyles": {
        fontWeight: "bolder !important",
        color: "white !important",
        fontSize: "15px !important ",
      },
      fontSize: "1rem",
    },
  };
});

export default useSimpleButtonStyles;
